import type { HeroSection } from "@/types/content";

interface Props {
  section: HeroSection;
}

export default function HeroSectionBlock({ section }: Props) {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      {section.backgroundImage && (
        <img
          loading="lazy"
          src={section.backgroundImage}
          alt={section.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 text-center px-4 md:px-8 max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          {section.title}
        </h1>
        {section.subtitle && (
          <p className="text-lg md:text-xl text-white/90 mb-6">
            {section.subtitle}
          </p>
        )}
        {section.cta && (
          <a
            href={section.cta.href}
            className="inline-block px-6 py-3 bg-primary text-white font-medium rounded-full hover:bg-primary-dark transition-colors whitespace-nowrap"
          >
            {section.cta.label}
          </a>
        )}
      </div>
    </section>
  );
}